import { render, staticRenderFns } from "./WithdrawalReason.vue?vue&type=template&id=f133fe5c&scoped=true&"
import script from "./WithdrawalReason.vue?vue&type=script&lang=js&"
export * from "./WithdrawalReason.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalReason.vue?vue&type=style&index=0&id=f133fe5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f133fe5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VDataTable,VPagination,VSimpleCheckbox,VSpacer})
